<template>
  <div class="flex flex-col items-end pt-[14px] mr-4">
    <OButton pure href="/oyun/leaderboard/emojile">
      <div class="flex pr-2 py-1 items-center rounded-[80px] badge-bg h-[26px] mb-1">
        <OImage :src="emojile.image[device]" class="w-6 h-6 mr-2" />
        <div v-if="player.emojile.rank" class="flex u-center">
          <p class="text-white text-sm font-bold mr-2">{{ player.emojile.rank }}.</p>
          <OIcon icon="onedioPuan" class="u-center w-3 h-3 mr-1" />
          <p class="text-[#F1B32B] text-sm font-bold">{{ player.emojile.score }}</p>
        </div>
        <div v-else class="flex u-center">
          <p class="text-white text-sm font-bold mr-2">
            {{ isLoggedIn && state.user._id === user._id ? 'Sıralamanı belirle' : 'Sıralama yok' }}
          </p>
          <OIcon icon="onedioPuan" class="u-center w-3 h-3 mr-1" />
          <p class="text-[#F1B32B] text-sm font-bold">0</p>
        </div>
      </div>
    </OButton>
    <OButton pure href="/oyun/leaderboard/bilpop">
      <div class="flex pr-2 py-1 items-center rounded-[80px] badge-bg h-[26px]">
        <OImage :src="bilpop.image[device]" class="w-6 h-6 mr-2" />
        <div v-if="player.bilpop.rank" class="flex u-center">
          <p class="text-white text-sm font-bold mr-2">{{ player.bilpop.rank }}.</p>
          <OIcon icon="onedioPuan" class="u-center w-3 h-3 mr-1" />
          <p class="text-[#F1B32B] text-sm font-bold">{{ player.bilpop.score }}</p>
        </div>
        <div v-else class="flex u-center">
          <p class="text-white text-sm font-bold mr-2">
            {{ isLoggedIn && state.user._id === user._id ? 'Sıralamanı belirle' : 'Sıralama yok' }}
          </p>
          <OIcon icon="onedioPuan" class="u-center w-3 h-3 mr-1" />
          <p class="text-[#F1B32B] text-sm font-bold">0</p>
        </div>
      </div>
    </OButton>
  </div>
</template>

<script>
import { defineComponent, ssrRef, useContext, useAsync } from '@nuxtjs/composition-api';
import { useProfile } from '@/modules/profile/state/useProfile';
import { OButton, OImage, OIcon } from '~/modules/common/components/ui';
import { useAuth } from '~/modules/auth/state/useAuth';
import { useMetadataConfig } from '~/modules/config/configUtils';
import { useDevice } from '~/composables/useDevice';

export default defineComponent({
  components: { OButton, OImage, OIcon },
  setup() {
    const { state } = useProfile();
    const { $service } = useContext();
    const { user, isLoggedIn } = useAuth();
    const player = ssrRef({});
    const { isMobile } = useDevice();
    const device = isMobile.value ? 'mobile' : 'desktop';
    const { badges } = useMetadataConfig();
    const emojile = badges.find((item) => item.href === '/emojile');
    const bilpop = badges.find((item) => item.href === '/bilpop');

    const getPlayerRank = async (gameName) => {
      try {
        const userParams = {
          boardType: gameName,
          duration: 'yearly',
          playerId: state.value.user?._id,
        };
        const { data } = await $service.game.getPlayerRank(userParams);
        player.value[gameName] = data;
      } catch (err) {
        console.log(err);
      }
    };
    useAsync(async () => {
      await Promise.all([getPlayerRank('bilpop'), getPlayerRank('emojile')]);
    });
    return { state, player, user, emojile, bilpop, isLoggedIn, device };
  },
});
</script>

<style lang="scss" scoped>
.badge-bg {
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(0, 0, 0, 0.8);
}
</style>
